import React from 'react';
import { useTranslation } from 'react-i18next';
import './AdminPagination.css';

const AdminPagination = ({ currentPage, totalPages, totalItems, itemsPerPage, onPageChange }) => {
  const { t } = useTranslation();
  if (totalItems === 0) return null;
  const from = (currentPage - 1) * itemsPerPage + 1;
  const to = Math.min(currentPage * itemsPerPage, totalItems);
  const showPagination = totalPages > 1;

  return (
    <div className="admin-pagination">
      <span className="admin-pagination-info">
        {t('admin.showingXOfY', { from, to, total: totalItems })}
      </span>
      {showPagination && (
        <div className="admin-pagination-controls">
          <button
            type="button"
            className="admin-pagination-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage <= 1}
            aria-label={t('admin.previous')}
          >
            {t('admin.previous')}
          </button>
          <span className="admin-pagination-pages">
            {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            className="admin-pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage >= totalPages}
            aria-label={t('admin.next')}
          >
            {t('admin.next')}
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminPagination;
